export default "__VITE_ASSET__CdsU1a5i__"